jQuery(document).ready(function ($) {
    var topBar;
    if ($('.top-bar-wrap').length !== 0) {
        topBar = $('.top-bar-wrap');
    } else if ($('.header-top').length !== 0) {
        topBar = $('.header-top');
    } else {
        topBar = $('#top-bar-sm');
    }
    var button = $('.nav-button'),
        navBar = $('.navbar'),
        navBarHeader = $('.navbar-header'),
        navSearch = $('#nav-fixed--input'),
        navCollapse = $('#nav-menu'),
        navFixedContainer = $('.nav-fixed + .container'),
        navContainer = $('.navbar + .container');

    var MOBILE_WIDTH = 991;

    if (window.disableStickyMenu) {
        enableStickyMenu(false);
    } else if (!(window.location.search.indexOf('esearch') > -1)) {
        enableStickyMenu(true);
    }

    /**
     *  Checks to see if device is mobile
     *  @returns {boolean}
     */
    function isMobiles() {
        return window.innerWidth <= MOBILE_WIDTH;
    }

    /**
     * Fix menu jumping issue, disables when content isn't longer than window.
     * @returns {boolean}
     */
    function isLong() {
        var contentClass = '.container-full-width';
        var container = $('body>.container');

        if (container.length) {
            contentClass = '.container';
        }

        var element = $('body>' + contentClass);
        var height = element.outerHeight();

        if (container.length === 3) {
            height = element.eq(1).outerHeight();
        }

        return window.outerHeight < height;
    }

    /**
     * Explicitly controls the height for the nav menu in case the nav menu height is set dynamically
     * Not currently necessary but acts as a failsafe in case bootstrap does some funny business
     * @returns {void}
     */
    function setNavMenuHeight() {
        let headerHeight = $('.nav-menu').outerHeight();
        let viewportHeight = $(window).height();
        $('#nav-menu.nav-active').css('max-height', (viewportHeight - headerHeight) + 'px');
    }

    /**
     * Enables the sticky menu if all criteria is met
     * @param search
     * @returns {boolean}
     */
    function enableStickyMenu(search) {
        if (search) {
            jQuery(window).on('resize', function () {
                if (isMobiles()) {
                    topBar.hide();
                    button.addClass('nav-button--hidden');
                    navBar.removeClass('navbar-active');
                    navSearch.removeClass('nav-search--fixed');
                } else {
                    topBar.show();
                    if ($(window).scrollTop() <= (topBar.height())) {
                        button.addClass('nav-button--hidden');
                        topBar.removeClass('top-bar-fixed');
                        navBar.removeClass('nav-fixed');
                    } else {
                        button.removeClass('nav-button--hidden');
                    }
                }
            });

            // Window scroll event
            $(window).scroll(function () {
                if (!isMobiles()) {
                    topBar.show();
                    // Desktop when not at top of screen
                    if ($(window).scrollTop() >= topBar.height() && isLong()) {
                        topBar.removeClass('hidden-sm');
                        topBar.removeClass('hidden-xs');

                        // Make nav sticky
                        navBar.addClass('nav-fixed');

                        // Fix navbar based on content size
                        if (navFixedContainer.length > 0) {
                            navFixedContainer.css('padding-top', navBar.height() + 'px');
                        } else if ($('.nav-fixed + .container-full-width').length > 0) {
                            $('.nav-fixed + .container-full-width').css('padding-top', navBar.height() + 'px');
                        }

                        // Show search button
                        button.removeClass('nav-button--hidden');

                    } else {
                        // Desktop when at top of screen
                        button.addClass('nav-button--hidden');
                        navSearch.removeClass('nav-search--fixed');

                        topBar.addClass('hidden-sm');
                        topBar.addClass('hidden-xs');
                        navBar.removeClass('nav-fixed');
                        navSearch.hide();

                        // Fix navbar based on content size
                        if (navContainer.length > 0) {
                            navContainer.css('padding-top', '');
                        } else if ($('.navbar + .container-full-width').length > 0) {
                            $('.navbar + .container-full-width').css('padding-top', '');
                        }
                    }
                } else if (isMobiles()) {
                    // Mobile when not at top of screen
                    if ($(window).scrollTop() > 0) {
                        navBar.addClass('nav-fixed');
                        if (navFixedContainer.length > 0) {
                            navFixedContainer.css('padding-top', navBarHeader.height() + 'px');
                        } else if ($('.nav-fixed + .container-full-width').length > 0) {
                            $('.nav-fixed + .container-full-width').css('padding-top', navBarHeader.height() + 'px');
                        }
                        button.addClass('nav-button--hidden');

                        topBar.hide();
                    } else {
                        // Mobile when at top of screen
                        navBar.removeClass('nav-fixed');

                        if (navContainer.length > 0) {
                            navContainer.css('padding-top', '');
                        } else if ($('.navbar + .container-full-width').length > 0) {
                            $('.navbar + .container-full-width').css('padding-top', '');
                        }

                        button.addClass('nav-button--hidden');

                        topBar.hide();
                    }
                }

            });

            // Search button click event
            (button).click(function (e) {
                e.stopPropagation();
                if (!navSearch.hasClass('nav-search--fixed')) {
                    // if search is not visible add class and focus
                    navSearch.show();
                    navSearch.addClass('nav-search--fixed').focus();
                } else if (navSearch.val() !== '') {
                    // if not empty submit the search
                    $('#google-search-form').submit();
                } else {
                    //if empty refocus the textarea
                    navSearch.focus();
                }

            });

            // Click anywhere besides the search button and text area remove textarea
            $(document.body).click(function () {
                navSearch.removeClass('nav-search--fixed');
                navSearch.hide();
            });

            navSearch.click(function (e) {
                e.stopPropagation();
            });

            // When typing in navsearch fill in the main search as well
            navSearch.keyup(function (e) {
                var hiddenSearch = $(this).val();
                $('#search').val(hiddenSearch);
                if (e.key === 'Enter') {
                    $('#google-search-form').submit();
                }
            });

            // When typing in main search fill in the nav search as well
            $('#search').keyup(function () {
                var searchVal = $(this).val();
                navSearch.val(searchVal);
            });

        } else {
            return false;
        }
    }

    $('#mobile-menu-toggle').click(function () {
        $(this).toggleClass('is-active');
        setNavMenuHeight();
        var height = $(window).height() - $('.navbar-header').height();
        if (!navCollapse.hasClass('nav-active')) {
            $('#searchbox-xs').removeClass('in');
            $('#searchbox-xs').addClass('collapse');

            navCollapse.addClass('nav-active');
            navCollapse.height(height + 'px');
            navCollapse.toggle();
        } else {
            navCollapse.removeClass('nav-active');
            navCollapse.height('0');
            navCollapse.toggle();
        }

    });

    $('#mobile-search-toggle').click(function () {
        if (navCollapse.hasClass('nav-active')) {
            navCollapse.removeClass('nav-active');
            navCollapse.height('0');
            navCollapse.toggle();
            $('#mobile-menu-toggle').toggleClass('is-active');
        }

        // Timeout to let searchbar be visible
        setTimeout(function () {
            $('#mobile-search').focus();
        }, 401);
    });

    $(window).on('load', function () {
        if (window.location.hash) {
            var hash = window.location.hash;
            if ($(hash).length) {
                $('html, body').animate({
                    scrollTop: $(hash).offset().top - $(navBar).height()
                }, 0);
            }
        }
    });

    $(window).on('hashchange', function () {
        if (window.location.hash) {
            var hashChange = window.location.hash;
            if ($(hashChange).length) {
                var top = $(hashChange).offset().top - $(navBar).height();
                $(window).scrollTop(top);
            }
        }
    });

    $(window).on('resize', setNavMenuHeight);

    // Fix icon for french
    if (typeof chartLanguage !== 'undefined' && chartLanguage === 'fr') {
        button.css('right', '0');
    } else {
        button.css('right', '');
    }
});
